import type { Pixel } from '@/data'
import api from '..'
import type { PixelPayload } from './createPixel'

export async function updatePixel(
  id: string,
  payload: Partial<PixelPayload>,
): Promise<Pixel> {
  const res = await api.put(`/pixels/${id}`, payload)
  return res.data.data
}
